export const atLeastFiveCharsRegexp: RegExp = new RegExp(/^.{5,}$/);
